import React from "react";
import { Redirect, Route } from "react-router-dom";
import { localStorageService } from "../_services/localStorage.service";

export const MasterAdminRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return localStorageService.isMaster() ? (
          <section className={`content`}>
            <Component {...props} {...rest} />
          </section>
        ) : (
          <Redirect to="/" />
        );
      }}
    />
  );
};
